import React from "react";
import renderInput from "helpers/FormGenerator";
import AdminLayout from "components/MainApp/layouts/DesktopLayout";

import styles from "./MainApp.organisms.OrdersV3.LocationModal.module.scss";
import i18n from "i18n";

export const LocationModal = ({
  fields,
  handleClose,
  handleSelect,
  handleAdd,
}) => {
  const content = (
    <div className={styles["location-modal-content-wrapper"]}>
      <div className={styles["location-modal-content"]}>
        {fields &&
          fields.map((field) => {
            return renderInput(field, handleSelect, {}, "prep-order-field");
          })}
      </div>
      <div className={styles["load-movement-items-buttons-wrapper"]}>
        <div
          className={`${styles["load-movement-items-button"]} ${styles["load-movement-items-add"]}`}
          onClick={handleAdd}
        >
          {" "}
          {i18n.t("add").toUpperCase()}{" "}
        </div>
      </div>
    </div>
  );
  return (
    <div className={styles["location-modal-container"]}>
      <AdminLayout
        headerTitle={i18n.t("add.location")}
        headerOptions={[]}
        content={content}
        closeFunc={handleClose}
        navHidden={true}
      ></AdminLayout>
    </div>
  );
};

export default LocationModal;
